var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03403 0.941772C4.07068 0.941772 0.00976562 5.00994 0.00976562 10.0204C0.00976562 14.5507 3.31264 18.3108 7.62624 18.9903V12.648H5.33408V10.0204H7.62624V8.01803C7.62624 5.74385 8.97086 4.49349 11.0374 4.49349C12.0211 4.49349 13.0498 4.66564 13.0498 4.66564V6.90359H11.9128C10.7938 6.90359 10.4418 7.60125 10.4418 8.31703V10.0204H12.9506L12.5445 12.648H10.4418V18.9903C12.5683 18.6531 14.5047 17.5638 15.9014 15.9189C17.2981 14.274 18.0631 12.1819 18.0583 10.0204C18.0583 5.00994 13.9974 0.941772 9.03403 0.941772Z",
    fill: "#889ABE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.74119939a02d830d4cb0390355229715.svg";
export { ForwardRef as ReactComponent };